import type { PointerEvent } from 'react';

import { useTooltip } from '../../../core/components/overlay-tooltip/contexts/TooltipContext.js';
import type { Data } from '../../../core/components/overlay-tooltip/types.js';
import { useTooltipReducer } from '../../../core/components/overlay-tooltip/useTooltipReducer.js';
import { emptyData } from '../../../core/components/overlay-tooltip/utils.js';

export const useMeterBarChartTooltipHandlers = (data: Data) => {
  const tooltip = useTooltip();
  const dispatch = useTooltipReducer();

  const onPointerMove = (event: PointerEvent<HTMLDivElement>) => {
    dispatch({
      type: 'SET_POSITION',
      payload: data,
    })(event);
  };

  const onPointerLeave = (event: PointerEvent<HTMLDivElement>) => {
    dispatch({ type: 'SET_OUT_BOUNDS' })(event);
  };

  const onClick = (event: PointerEvent<HTMLDivElement>) => {
    if (tooltip.getState().pinned) {
      dispatch({
        type: 'SET_PINNED',
        payload: {
          pinned: false,
          data: emptyData(),
        },
      })();
    } else {
      const { offsetX, offsetY } = event.nativeEvent;
      dispatch({
        type: 'SET_PINNED',
        payload: {
          pinned: true,
          relativeX: offsetX,
          relativeY: offsetY,
          data,
        },
      })();
    }
  };

  return { onClick, onPointerMove, onPointerLeave };
};
